import { Mic, Settings, Target } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      number: "1",
      icon: Mic,
      title: "Capture everything in seconds",
      description: "Use Quick Capture (+) to log leads, tasks, invoices, income, and expenses in a single line — by text, click, or voice. Catlyo understands what you mean and sends it to the right module."
    },
    {
      number: "2",
      icon: Settings,
      title: "Let the OS organize and prioritize",
      description: "Tasks automatically link to projects and clients. Deals move through your sales pipeline. Invoices flow into Finance. The Super Queue ranks what truly matters today using revenue and risk logic."
    },
    {
      number: "3",
      icon: Target,
      title: "Act from one calm dashboard",
      description: "Follow up on leads, chase overdue invoices, complete tasks, and move goals forward — all from one screen, with AI explaining which actions will move the needle right now."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">
            How Catlyo fits into your day.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                {/* Connector line (hidden on mobile) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-border" style={{ zIndex: 0 }} />
                )}
                
                <div className="relative z-10 space-y-4 text-center">
                  {/* Number badge */}
                  <div className="inline-flex h-24 w-24 rounded-full bg-primary/10 items-center justify-center mx-auto border-4 border-background">
                    <div className="flex flex-col items-center">
                      <Icon className="h-8 w-8 text-primary mb-1" />
                      <span className="text-sm font-bold text-primary">Step {step.number}</span>
                    </div>
                  </div>
                  
                  <h3 className="text-xl font-semibold">{step.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
